'use client';

const NotFound = () => {
  return (
    <html lang="en">
      <body>
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for could not be found.</p>
      </body>
    </html>
  );
};

export default NotFound;
